import React, { useState } from "react";
import { Overlay, Popover } from "react-bootstrap";
import ReactMarkdown from "react-markdown";

// This component will store the content of a text cell into a popover and replace it
// with a generic "view". When "view" is clicked, the popover will display the text.
// The text is rendered in markdown! The "view" will be changed to "hide".
// When "hide" is clicked (or if another popover is clicked) this popover will hide.
function NotePopover(props) {
  const { value } = props;
  const [label, setLabel] = useState("View");
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const onEntering = () => {
    setLabel("Hide");
  };

  const onExiting = () => {
    setLabel("View");
  };

  const onHide = () => {
    setShow(false);
    setLabel("View");
  };

  return value ? (
    <>
      <button className={"link-button"} onClick={handleClick}>
        {label}
      </button>
      <Overlay
        show={show}
        target={target}
        placement="left"
        rootClose={true}
        onHide={onHide}
        rootCloseEvent={"click"}
        onEntering={onEntering}
        onExiting={onExiting}
      >
        <Popover>
          <Popover.Content>
            {<ReactMarkdown>{value}</ReactMarkdown>}
          </Popover.Content>
        </Popover>
      </Overlay>
    </>
  ) : (
    ""
  );
}

export default NotePopover;
